import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IInitState {
  isLoading: boolean;
  neapDeliveryList: any;
  csvNeapDeliveryList:any;
  neapDeliveryExecutionList:any;
  singleDeliveryDetailsCsv:any;
  error: any;
}

const initialState: IInitState = {
  isLoading: false,
  neapDeliveryList: [],
  csvNeapDeliveryList: [],
  neapDeliveryExecutionList: [],
  singleDeliveryDetailsCsv:[],
  error: false,
};

const neapDeliverySlice = createSlice({
  name: "neapDelivery",
  initialState: initialState,
  reducers: {
    neapDeliveryRequest(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    singleNeapDeliveryRequest(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    neapDeliverySuccess(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.neapDeliveryList = action.payload;
    },
    singleNeapDeliverySuccess(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.singleDeliveryDetailsCsv = action.payload;
    },
    singleNeapDeliveryError(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.singleDeliveryDetailsCsv = [];
    },
    neapDeliveryError(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.neapDeliveryList = [];
    },
    csvNeapDeliveryRequest(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    csvNeapDeliverySuccess(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.csvNeapDeliveryList = action.payload;
    },
    csvNeapDeliveryError(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.csvNeapDeliveryList = [];
    },
    neapDeliveryExecutionRequest(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = true;
    },
    neapDeliveryExecutionSuccess(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.neapDeliveryExecutionList = action.payload;
    },
    neapDeliveryExecutionError(state: IInitState, action: PayloadAction<any>) {
      state.isLoading = false;
      state.neapDeliveryExecutionList = [];
    },
  },
});

export const {
    neapDeliveryRequest,
    neapDeliverySuccess,
    csvNeapDeliveryRequest,
    csvNeapDeliverySuccess,
    neapDeliveryExecutionRequest,
    neapDeliveryExecutionSuccess,
    neapDeliveryError,
    csvNeapDeliveryError,
    neapDeliveryExecutionError,
    singleNeapDeliveryRequest,
    singleNeapDeliverySuccess,
    singleNeapDeliveryError

} = neapDeliverySlice.actions;

export default neapDeliverySlice.reducer;
